import { useQuery } from "@tanstack/react-query";
import FETCHER from "./_fetcher";
import {
  CapsulePointTransaction,
  PointsTransactionListResponse,
  PointsTransactionFilters,
  PointsTransactionType,
} from "types/pointsTransaction";

// Get Points Transactions with filters
export const getPointsTransactions = async (
  filters: PointsTransactionFilters = {}
): Promise<PointsTransactionListResponse> => {
  try {
    const params = new URLSearchParams();

    if (filters.page) params.append("page", filters.page.toString());
    if (filters.limit) params.append("limit", filters.limit.toString());

    const result = await FETCHER.get<PointsTransactionListResponse>(
      `/user/capsule-point-transactions?${params.toString()}`
    );
    return result.data;
  } catch (e) {
    console.error("Failed to get points transactions:", e);
    throw e;
  }
};

export const useGetPointsTransactions = (
  filters: PointsTransactionFilters = {},
  enabled: boolean = true
) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["getPointsTransactions", filters],
    queryFn: () => getPointsTransactions(filters),
    enabled,
    retry: 2,
    staleTime: 30000,
  });

  return {
    transactions: data?.transactions || [],
    currentPage: data?.meta?.currentPage || 1,
    itemsPerPage: data?.meta?.itemsPerPage || 10,
    totalItems: data?.meta?.totalItems || 0,
    totalPages: data?.meta?.totalPages || 1,
    isLoading,
    error,
    refetch,
  };
};

// Helper function to format transaction type for display
export const getTransactionTypeLabel = (
  type: PointsTransactionType | null
): string => {
  switch (type) {
    case PointsTransactionType.ORDER:
      return "คะแนนที่ได้รับจากการสั่งซื้อ";
    case PointsTransactionType.ADMIN_ADJUST:
      return "ปรับคะแนนโดยผู้ดูแลระบบ";
    case PointsTransactionType.REFERRAL:
      return "คะแนนที่ได้รับจากการแนะนำ";
    case PointsTransactionType.REDEMPTION_DISCOUNT:
      return "ใช้คะแนนเป็นส่วนลด";
    case PointsTransactionType.REDEMPTION_HYBRID:
      return "แลกซื้อสินค้า (คะแนน + เงิน)";
    case PointsTransactionType.REDEMPTION_POINTS_ONLY:
      return "แลกซื้อสินค้า (คะแนน)";
    default:
      return "รายการอื่นๆ";
  }
};

// Check if a transaction type has an associated order link
export const hasOrderLink = (tx: CapsulePointTransaction): boolean => {
  return tx.orderId !== null;
};
